<template>
  <div class="tuolele-index">
    <Tablist
      :list.sync="tabList"
      :active-id="activeIndex"
      @updateCurrentPage="updateCurrentPage"
    />
    <div class="tuolele-main-box">
      <div class="table-filter">
        <div class="second-filter fn-clear">
          <div
            class="second-all fn-left"
            :class="{ active: activeIndex == secondIndex }"
            @click="secondAll(activeIndex)"
          >
            全部
          </div>
          <div class="second-list flex-wrap">
            <div
              v-for="item in secondList"
              :key="item.id"
              class="second-item"
              :class="{ active: item.id == secondIndex }"
              @click="selectSecond(item.id)"
            >
              {{ item.directory_name }}
            </div>
          </div>
        </div>
        <div v-show="thirdList.length > 0" class="third-filter fn-clear">
          <div
            class="third-all fn-left"
            :class="{ active: secondIndex == thirdIndex }"
            @click="thirdAll(secondIndex)"
          >
            全部
          </div>
          <div class="third-list flex-wrap">
            <div
              v-for="item in thirdList"
              :key="item.id"
              class="third-item"
              :class="{ active: item.id == thirdIndex }"
              @click="selectThird(item.id)"
            >
              {{ item.directory_name }}
            </div>
          </div>
        </div>
      </div>
      <div class="table-main">
        <div class="table-header fn-clear">
          <div class="fn-left table-header-left flex-wrap">
            <div
              :class="{
                active:
                  filterObj.order_sort == '' && filterObj.is_recommend == ''
              }"
              @click="selectDefault"
            >
              默认
            </div>
            <div
              :class="{ active: filterObj.order_sort == 3 }"
              @click="selectNew(3)"
            >
              最新上线
            </div>
            <div
              :class="{ active: filterObj.is_recommend == 1 }"
              @click="selectRecommend(1)"
            >
              推荐必看
            </div>
          </div>
          <div class="fn-right table-header-right">
            <el-pagination
              :current-page.sync="filterObj.p"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="filterObj.limit"
              layout="sizes, prev, slot, next"
              prev-text="上一页"
              next-text="下一页"
              :total="itemTotal"
              @size-change="handleSizeChange"
            >
              <div class="chax">
                {{ filterObj.p }}/{{
                  itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
                }}
              </div>
            </el-pagination>
          </div>
        </div>
        <div class="table-body flex-wrap">
          <div
            v-for="item in itemList"
            :key="item.id"
            class="table-item"
            @click="toDetails(item.id)"
          >
            <div
              class="type-icon"
              :class="{ img: item.type == 1, video: item.type == 2 }"
            />
            <div v-show="item.is_recommend == 1" class="recommend-img" />
            <div class="table-img img-wrap-x">
              <img
                :src="
                  item.cover
                    ? `${item.cover}?imageMogr2/thumbnail/375x`
                    : defaultImg
                "
                alt=""
                class="center-self"
              >
            </div>
            <div class="table-info">
              <div v-show="item.attachments.length > 0" class="file-icon" />
              <div v-show="item.i_read == 0" class="new-icon">NEW</div>
              <div class="table-item-title">{{ item.title }}</div>
              <div class="table-item-content">
                {{ item.time_frame_array.join("，") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="filterObj.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="filterObj.limit"
        >
          <div class="chax">
            {{ filterObj.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span
            class="pagination-count"
          >符合查询结果:<i>{{ itemTotal }}条</i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tablist from '@/components/toolbar/Tablist.vue'
export default {
  name: 'TuoleleIndex',
  components: {
    Tablist
  },
  data() {
    return {
      defaultImg: require('@/assets/img/tuolele-default.png'),
      tabList: [], // 一级分类菜单
      activeIndex: '', // 当前一级分类
      secondIndex: '', // 当前二级分类
      thirdIndex: '', // 当前三级分类
      secondList: [], // 二级分类菜单
      thirdList: [], // 三级分类菜单
      itemList: [], // 资料列表
      itemTotal: 0, // 资料总数
      filterObj: {
        // 筛选参数
        p: 1,
        limit: 10,
        directory_id: '',
        is_recommend: '',
        order_sort: ''
      }
    }
  },
  watch: {
    filterObj: {
      handler(newVal) {
        this.getArticleList(newVal)
      },
      deep: true
    }
  },
  mounted() {
    this.getDirectoryList()
  },
  methods: {
    updateCurrentPage(newVal) {
      this.activeIndex = newVal
      this.filterObj.directory_id = newVal
      this.secondList =
        this.tabList.filter(e => {
          return e.id == newVal
        })[0]._child || []
      this.secondIndex = newVal
      this.thirdList = []
    },
    async getDirectoryList() {
      const ret = await this.$http.getDirectoryList()
      if (ret.code == 200) {
        this.tabList = ret.data
        this.activeIndex = this.tabList[0].id
        this.filterObj.directory_id = this.activeIndex
        this.secondIndex = this.activeIndex
        this.secondList =
          this.tabList.filter(e => {
            return e.id == this.activeIndex
          })[0]._child || []
      }
    },
    async getArticleList(filterObj) {
      const ret = await this.$http.getArticleList(filterObj)
      this.itemList = ret.data.list
      this.itemTotal = ret.data.count - 0
    },
    handleSizeChange(val) {
      this.filterObj.limit = val
    },
    selectSecond(val) {
      this.filterObj.directory_id = val
      this.secondIndex = val
      this.thirdIndex = val
      this.thirdList =
        this.secondList.filter(e => {
          return e.id == val
        })[0]._child || []
    },
    selectThird(val) {
      this.filterObj.directory_id = val
      this.thirdIndex = val
    },
    secondAll(val) {
      this.filterObj.directory_id = val
      this.secondIndex = val
      this.thirdList = []
    },
    thirdAll(val) {
      this.filterObj.directory_id = val
      this.thirdIndex = val
    },
    selectNew(val) {
      this.filterObj.order_sort = val
      this.filterObj.is_recommend = ''
    },
    selectRecommend(val) {
      this.filterObj.is_recommend = val
      this.filterObj.order_sort = ''
    },
    selectDefault() {
      this.filterObj.order_sort = ''
      this.filterObj.is_recommend = ''
    },
    toDetails(id) {
      this.$router.push({
        path: 'tuoleleCourseDetails',
        query: { id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tuolele-index {
  .tuolele-main-box {
    .table-filter {
      border-bottom: 1px solid #f5f5f5;
      font-size: 14px;
      .second-filter {
        color: $color_black;
        margin-bottom: 22px;
        padding: 0 20px;
        .second-all {
          cursor: pointer;
          font-size: 16px;
          &.active {
            color: $color_blue;
          }
        }
        .second-list {
          overflow: hidden;
          flex-wrap: wrap;
          .second-item {
            margin-left: 30px;
            margin-bottom: 20px;
            font-size: 16px;
            cursor: pointer;
            &.active {
              color: $color_blue;
            }
          }
        }
      }
      .third-filter {
        margin-bottom: 42px;
        padding: 20px 20px 0;
        background-color: #fafafa;
        border: solid 1px #ebebeb;
        .third-all {
          cursor: pointer;
          font-size: 16px;
          &.active {
            color: $color_blue;
          }
        }
        .third-list {
          overflow: hidden;
          flex-wrap: wrap;
          .third-item {
            font-size: 16px;
            margin-left: 30px;
            margin-bottom: 20px;
            cursor: pointer;
            &.active {
              color: $color_blue;
            }
          }
        }
      }
    }
    .table-main {
      padding-top: 40px;
      .table-header {
        border-bottom: 1px solid #f5f5f5;
        padding-left: 10px;
        .table-header-left {
          div {
            color: $color_black;
            margin-right: 30px;
            line-height: 40px;
            font-size: 16px;
            position: relative;
            padding-bottom: 20px;
            cursor: pointer;
            &.active {
              color: $color_blue;
              &::before {
                position: absolute;
                content: "";
                width: 0;
                height: 0;
                border-width: 7px 5px;
                border-style: solid;
                border-color: transparent transparent $color_blue transparent;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: 0;
              }
            }
          }
        }
      }
      .table-body {
        flex-wrap: wrap;
        .table-item {
          margin-top: 20px;
          width: 375px;
          margin-right: 10px;
          position: relative;
          cursor: pointer;
          .recommend-img {
            position: absolute;
            width: 80px;
            height: 80px;
            top: 0px;
            left: 0px;
            background: url("../../assets/img/recommend-img.png") no-repeat
              center center;
            background-size: 100%;
            z-index: 1;
          }
          .type-icon {
            z-index: 1;
            position: absolute;
            width: 38px;
            height: 38px;
            border-radius: 500px;
            top: 12px;
            right: 12px;
            &.img {
              background: rgba(0, 0, 0, 0.2)
                url("../../assets/img/image-icon.png") no-repeat center center;
              background-size: 20px;
            }
            &.video {
              background: rgba(0, 0, 0, 0.2)
                url("../../assets/img/video-icon.png") no-repeat center center;
              background-size: 20px;
            }
          }
          .table-img {
            width: 100%;
            height: 280px;
            border-radius: 10px 10px 0 0;
            overflow: hidden;
            position: relative;
          }
          .table-info {
            padding: 25px 30px;
            height: 125px;
            box-sizing: border-box;
            border: solid 1px #ebebeb;
            border-top: none;
            border-radius: 0 0 10px 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            position: relative;
            .file-icon {
              position: absolute;
              width: 20px;
              height: 20px;
              top: 25px;
              right: 10px;
              background: url("../../assets/img/link-icon.png") no-repeat center
                center;
              background-size: 100%;
            }
            .new-icon {
              padding: 0 4px;
              color: #fff;
              font-size: 14px;
              background-color: #ff6f50;
              border-radius: 2px;
              position: absolute;
              bottom: 28px;
              right: 10px;
            }
            .table-item-title {
              color: $color_black;
              font-size: 18px;
              margin-bottom: 10px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .table-item-content {
              font-size: 14px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}

.el-button.el-button--primary {
  width: 90px !important;
  height: 40px !important;
}
</style>
